var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWalletNonce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12441_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.35 1.5C29.8682 1.5 30.2805 1.85714 30.2805 2.30612V17.6939C30.2805 18.1429 29.8682 18.5 29.35 18.5H2.66176C2.14354 18.5 1.73132 18.1429 1.73132 17.6939V2.30612C1.73132 1.85714 2.14354 1.5 2.66176 1.5H29.3382M29.3382 0H2.66176C1.18955 0 0 1.03061 0 2.30612V17.6939C0 18.9694 1.18955 20 2.66176 20H29.3382C30.8105 20 32 18.9694 32 17.6939V2.30612C32 1.03061 30.8105 0 29.3382 0Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.35 5.5C29.8682 5.5 30.2805 5.85714 30.2805 6.30612V21.6939C30.2805 22.1429 29.8682 22.5 29.35 22.5H2.66176C2.14354 22.5 1.73132 22.1429 1.73132 21.6939V6.30612C1.73132 5.85714 2.14354 5.5 2.66176 5.5H29.3382M29.3382 4H2.66176C1.18955 4 0 5.03061 0 6.30612V21.6939C0 22.9694 1.18955 24 2.66176 24H29.3382C30.8105 24 32 22.9694 32 21.6939V6.30612C32 5.03061 30.8105 4 29.3382 4Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L20.9566 12.1862L32 8.7044V21.4742C32 22.873 30.6814 24 29.0449 24H2.95511C1.31862 24 0 22.873 0 21.4742V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73068 9.88176L20.5681 13.6352L21.0743 13.7358L21.557 13.5849L30.2693 10.8377V21.4843C30.2693 22.0579 29.716 22.5308 29.0449 22.5308H2.95511C2.28403 22.5308 1.73068 22.0579 1.73068 21.4843V9.8717M0 8V21.4742C0 22.873 1.31862 24 2.95511 24H29.0449C30.6814 24 32 22.873 32 21.4742V8.7044L20.9566 12.1862L0 8.02013V8Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12441_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletNonce);
export default __webpack_public_path__ + "static/media/IconWalletNonce.1128d6c1.svg";
export { ForwardRef as ReactComponent };